import { render, staticRenderFns } from "./VTRomSettings.vue?vue&type=template&id=21ec8f72&"
import script from "./VTRomSettings.vue?vue&type=script&lang=js&"
export * from "./VTRomSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports